import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { ShiftService } from '../shift.service';

@Component({
  selector: 'app-add-shift',
  templateUrl: './add-shift.component.html',
  styleUrls: ['./add-shift.component.scss']
})
export class AddShiftComponent implements OnInit {
  model = {
  'Name': '',
  'Description': '',
  'EndTime': '',
  'StartTime': '',
  'Day': '',
  'DriverLimit': 0,
  'Date': '',
  'ShiftType': '',
  'CityId': 0,
  };
  constructor(
    private toastr: ToastrService,
    private router: Router,
    private shiftServices: ShiftService

  ) { }

  ngOnInit() {
  }
  onSubmit () {
    debugger;
    console.log(this.model);
      // tslint:disable-next-line:radix
  this.model.CityId = parseInt(localStorage.getItem('cityId')) ;
    this.shiftServices.AddShift(this.model).subscribe((Data: any) => {
      if (!Data.id) {
        this.toastr.success('Successfully Added');
        this.router.navigateByUrl('/shifts');
      }
    }, error => {
      this.toastr.error(error.error.Message);
    });
  }
}
